import React from 'react';

export default function MobileTopBar({ canUndo, canRedo, onUndo, onRedo, onDelete, onSave, activeObject, productName, darkMode, isEmbedded }) {
  return (
    <div className="mobile-top-bar">
      {/* Zurück zum Shop — embedded mode */}
      {isEmbedded ? (
        <button
          onClick={() => { if (window.parent !== window) window.parent.postMessage({ type: 'designer-close' }, '*'); }}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, borderRadius: 6, background: 'linear-gradient(135deg, #00ff88, #00ccff)', border: 'none', cursor: 'pointer', flexShrink: 0, touchAction: 'manipulation' }}
          title="Zurück zum Shop"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg>
        </button>
      ) : (
        <div style={{ width: 28, height: 28, borderRadius: 6, background: 'linear-gradient(135deg, #1a56db, #3b82f6)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>S</span>
        </div>
      )}

      {/* Product name / Zurück */}
      {isEmbedded ? (
        <span
          onClick={() => { if (window.parent !== window) window.parent.postMessage({ type: 'designer-close' }, '*'); }}
          style={{ flex: 1, fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer', touchAction: 'manipulation' }}
        >
          Zurück zum Shop
        </span>
      ) : (
        <span style={{ flex: 1, fontSize: 13, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', opacity: 0.7 }}>
          {productName || 'Designer'}
        </span>
      )}

      {/* Action buttons */}
      <button onClick={onUndo} disabled={!canUndo} title="Rückgängig">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 14 4 9 9 4" /><path d="M20 20v-7a4 4 0 0 0-4-4H4" />
        </svg>
      </button>
      <button onClick={onRedo} disabled={!canRedo} title="Wiederholen">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 14 20 9 15 4" /><path d="M4 20v-7a4 4 0 0 1 4-4h12" />
        </svg>
      </button>
      {activeObject && (
        <button onClick={onDelete} style={{ color: '#ef4444' }} title="Löschen">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          </svg>
        </button>
      )}
      <button onClick={onSave} title="Speichern">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" />
        </svg>
      </button>
    </div>
  );
}
